module.exports = __webpack_public_path__ + "view_manager.2233a37d22ea2f04e39418072355f7e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/view_manager.svg
// module id = 345
// module chunks = 0